import React from "react";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    experience: "Experience",
    present: "Present",
    employees: "employees",
    sector: "Sector",
    not_specified: "Not specified",
    no_experience: "No professional experience listed",
  },
  fr: {
    experience: "Expérience",
    present: "Présent",
    employees: "employés",
    sector: "Secteur",
    not_specified: "Non spécifié",
    no_experience: "Aucune expérience professionnelle renseignée",
  },
};

export default function ExperiencesTab({ candidate }) {
  const { t } = useComponentTranslation(translations);

  if (!candidate?.experiences?.length) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">💼</div>
        <p className="text-gray-500">{t("no_experience")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {candidate.experiences.map((experience) => (
        <div key={experience._id} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-gray-900 mb-1">{experience.title}</h3>
              <p className="text-sm text-gray-700 font-medium">
                {experience.company}
                {experience.company_workforce && (
                  <span className="text-xs text-gray-500 ml-2">
                    ({experience.company_workforce} {t("employees")})
                  </span>
                )}
              </p>
            </div>
            <span className="text-xs font-medium bg-blue-50 text-blue-700 px-2 py-1 rounded-lg border border-blue-100 whitespace-nowrap ml-4">
              {experience.from ? new Date(experience.from).toLocaleDateString() : ""} - {experience.to ? new Date(experience.to).toLocaleDateString() : t("present")}
            </span>
          </div>
          
          {experience.sector && (
            <div className="mt-2 pt-2 border-t border-gray-100">
              <span className="text-xs text-gray-500">{t("sector")}: </span>
              <span className="text-xs text-gray-700 font-medium">{experience.sector}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
